import { render } from "./SubMenu.html?vue&type=template&id=26b2db4a&scoped=true&ts=true&external"
import script from "./SubMenu.ts?vue&type=script&lang=ts&external"
export * from "./SubMenu.ts?vue&type=script&lang=ts&external"

import "./SubMenu.scss?vue&type=style&index=0&id=26b2db4a&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b2db4a"]])

export default __exports__